module.exports = __webpack_public_path__ + "static/media/alert.f2d1f382.svg";